<section class="section section--problem" aria-labelledby="programme-problem-title">
  <div class="wrap">
    <div class="readable">
      <p class="eyebrow">The missing assessment layer</p>
      <h2 class="title" id="programme-problem-title">Your Programme Defines Progress. <br />Participants Still Need a Way to See It.</h2>
      <p>
        A course may already define the skills, behaviours or outcomes participants should develop. What is often missing is a consistent
        way for people to assess where they are now, understand what different scores mean and revisit the same questions later. An embedded
        assessment wheel provides that structure without requiring you to design and build a digital tool from scratch.
      </p>
    </div>
    <dl class="mapping-list" aria-label="Programme content mapped to an embedded assessment">
      <div>
        <dt>Programme</dt>
        <dd>The Wheel</dd>
      </div>
      <div>
        <dt>Defined learning outcomes</dt>
        <dd>Clear assessment categories</dd>
      </div>
      <div>
        <dt>Goals and progress criteria</dt>
        <dd>Practical scoring guidance</dd>
      </div>
      <div>
        <dt>Static worksheets</dt>
        <dd>A visual exercise on your website</dd>
      </div>
    </dl>
  </div>
</section>

<section class="section section--installation" aria-labelledby="installation-title">
  <div class="wrap">
    <div class="readable section-intro">
      <p class="eyebrow">How it works</p>
      <h2 class="title" id="installation-title">From Programme Content to a Live Assessment</h2>
    </div>
    <ol class="installation-steps">
      <li>
        <span>1</span>
        <h3>You: Share the use case</h3>
        <p>Send the programme context, categories, website URL.</p>
      </li>
      <li>
        <span>2</span>
        <h3>I: Confirm compatibility and scope</h3>
        <p>The website and any result-delivery requirements are reviewed.</p>
      </li>
      <li>
        <span>3</span>
        <h3>I: Configure and install</h3>
        <p>The wheel and dedicated page are prepared and added to the approved website.</p>
      </li>
      <li>
        <span>4</span>
        <h3>Review and launch</h3>
        <p>Check the installed version and use the two included revision rounds where needed.</p>
      </li>
    </ol>
    <p class="timeline">
      <strong>Timeline:</strong> A standard installation is usually completed within three working days after final content and website
      access are received. Website restrictions or additional result-delivery requirements may affect timing.
    </p>
  </div>
</section>
